'use strict';
module.exports = require('./ProgressBar.vue');